<!-- ══════ NIVEAU 0 — BANDEAU (1ère détection) ══════ -->
<div class="alert-banner fixed top-0 left-0 right-0 z-[910] bg-slate-900 border-b-2 border-lilate
            py-[13px] px-6 flex items-center gap-3.5 shadow-[0_4px_20px_rgba(0,0,0,0.2)]"
     [class.visible]="level() === 'banner'">

  <div class="w-8 h-8 shrink-0 rounded-lg bg-lilate/15 border border-lilate/30
              flex items-center justify-center">
    <svg class="w-[15px] h-[15px] stroke-lilate" viewBox="0 0 24 24" fill="none"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <line x1="12" y1="8" x2="12" y2="12"/>
      <line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
  </div>

  <span class="flex-1 font-dm-sans text-[13.5px] text-slate-300 leading-relaxed">
    <strong class="text-white" translate>exam-tab-switch.banner-title</strong>&nbsp;
    <span translate>exam-tab-switch.banner-message</span>
  </span>

  <button class="py-[7px] px-4 bg-lilate/20 border border-lilate/40 text-lilate
                 rounded-lilate-sm font-dm-sans text-[13px] font-semibold cursor-pointer
                 whitespace-nowrap shrink-0 transition-colors hover:bg-lilate/[0.35]"
          (click)="dismiss()">
    <span translate>exam-tab-switch.banner-cta</span>
  </button>
</div>

<!-- ══════ NIVEAU 1 — OVERLAY AVERTISSEMENT (détections suivantes) ══════ -->
<div class="alert-overlay fixed inset-0 z-[920] flex items-center justify-center p-5"
     [class.visible]="level() === 'warning'">

  <div class="alert-card relative bg-white rounded-[18px] max-w-[480px] w-full
              shadow-[0_32px_80px_rgba(0,0,0,0.3),0_4px_20px_rgba(0,0,0,0.08)] overflow-hidden">

    <!-- Header sombre -->
    <div class="alert-header bg-slate-900 pt-[26px] px-7 pb-[22px] relative">
      <div class="inline-flex items-center gap-[7px] font-dm-sans text-[10px] font-bold
                  uppercase tracking-widest py-1 px-[11px] rounded-full mb-3
                  bg-lilate/15 text-lilate border border-lilate/30">
        <span class="badge-dot w-1.5 h-1.5 rounded-full bg-current"></span>
        <span translate>exam-tab-switch.badge</span>
      </div>
      <div class="font-dm-serif text-[23px] text-white leading-[1.15] tracking-tight mb-[5px]"
           translate>exam-tab-switch.warning-title</div>
      <div class="text-[13.5px] text-slate-500 leading-relaxed"
           translate>exam-tab-switch.warning-subtitle</div>
    </div>

    <!-- Body -->
    <div class="pt-[22px] px-7 pb-6">
      <p class="font-dm-sans text-[15px] text-slate-700 leading-[1.7] mb-[18px]"
         translate>exam-tab-switch.warning-text</p>

      <button class="w-full py-[13px] px-5 bg-lilate text-white border-none rounded-lilate
                     font-dm-sans text-[14.5px] font-bold cursor-pointer
                     transition-all hover:bg-lilate-dark hover:-translate-y-px"
              (click)="dismiss()">
        <span translate>exam-tab-switch.resume-test</span>
      </button>
    </div>

  </div>
</div>
